import { ApiSuccess, ApiTagTypes } from '../../types';
import { apiSlice } from '../api.services';

type CreateCoachingTemplatePayload = {
  name: string;
  prompt: string;
  tags?: string[];
};

type UpdateCoachingTemplatePayload = {
  id: string;
  name?: string;
  prompt?: string;
  tags?: string[];
};

const enhancedApiSliceSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createCoachingTemplate: builder.mutation<ApiSuccess, CreateCoachingTemplatePayload>({
      query: (coachingTemplateData) => ({
        url: '/coaching-templates',
        method: 'POST',
        body: coachingTemplateData,
      }),
      invalidatesTags: [ApiTagTypes.COACHING_TEMPLATES, ApiTagTypes.COACHING_TEMPLATES_FOR_SELECT],
    }),
    updateCoachingTemplate: builder.mutation<ApiSuccess, UpdateCoachingTemplatePayload>({
      query: ({ id, ...templateData }) => ({
        url: `/coaching-templates/${id}`,
        method: 'POST',
        body: templateData,
      }),
      invalidatesTags: (_, __, { id }) => [
        { type: ApiTagTypes.COACHING_TEMPLATES, id },
        ApiTagTypes.COACHING_TEMPLATES,
        ApiTagTypes.COACHING_TEMPLATES_FOR_SELECT,
      ],
    }),
    duplicateCoachingTemplate: builder.mutation<ApiSuccess, string>({
      query: (id) => ({
        url: `/coaching-templates/${id}/duplicate`,
        method: 'POST',
      }),
      invalidatesTags: [ApiTagTypes.COACHING_TEMPLATES, ApiTagTypes.COACHING_TEMPLATES_FOR_SELECT],
    }),
    deleteCoachingTemplate: builder.mutation<ApiSuccess, string>({
      query: (id) => ({
        url: `/coaching-templates/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [ApiTagTypes.COACHING_TEMPLATES, ApiTagTypes.COACHING_TEMPLATES_FOR_SELECT],
    }),
    archiveCoachingTemplate: builder.mutation<ApiSuccess, string>({
      query: (id) => ({
        url: `/coaching-templates/${id}/archive`,
        method: 'POST',
      }),
      invalidatesTags: (_, __, id) => [
        { type: ApiTagTypes.COACHING_TEMPLATES, id },
        ApiTagTypes.COACHING_TEMPLATES,
        ApiTagTypes.COACHING_TEMPLATES_FOR_SELECT,
      ],
    }),
  }),
});

export const {
  useCreateCoachingTemplateMutation,
  useUpdateCoachingTemplateMutation,
  useDuplicateCoachingTemplateMutation,
  useDeleteCoachingTemplateMutation,
  useArchiveCoachingTemplateMutation,
} = enhancedApiSliceSlice;
